// extracted by mini-css-extract-plugin
export default {"container":"UpgradeButton_container__zgNj9"};